import 'restangular/dist/restangular.min';
import 'bootstrap-sass/assets/javascripts/bootstrap.min';
require('./assets/javascripts/angular-ui-utils/ui-utils.min.js');
import 'datejs';